module.exports = __webpack_public_path__ + "static/img/product_onboarding.957e36e0.svg";